import { Directive, EmbeddedViewRef, Input, OnChanges, OnDestroy, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeaturesService } from '../services/features.service';
import { FeatureAuthModel } from '../models/feature-auth.model';
import { ConfigurationService } from '../services/configuration.service';
import { Features } from '@shared/DTO/features';
import { ListFeature } from '@shared/DTO/listFeature';
import { filter, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appFeaturesAuth]',
})
export class FeaturesAuthDirective implements OnChanges, OnDestroy {
  private _feature: FeatureAuthModel;
  @Input() set appFeaturesAuth(feature: FeatureAuthModel) {
    this._feature = feature;
  }

  private _featuresOptions: Features;
  @Input() set appFeaturesAuthOptions(options: Features) {
    this._featuresOptions = options;
  }

  private get features(): Features {
    const { features } = this._featuresOptions ?? this.featuresService.features;
    return features || {};
  }

  private onFeaturesUpdate$: Subscription;

  constructor(
    private viewContainer: ViewContainerRef,
    private template: TemplateRef<Object>,
    private renderer: Renderer2,
    private featuresService: FeaturesService,
    private configurationService: ConfigurationService
  ) {
    this.onFeaturesUpdate$ = this.featuresService
      .onFeaturesUpdate()
      .pipe(
        filter(() => !!this._feature),
        tap(() => this.evaluateFeature()),
      )
      .subscribe();
  }

  ngOnChanges(): void {
    if (this._feature) {
      this.evaluateFeature();
    }
  }

  ngOnDestroy(): void {
    this.onFeaturesUpdate$.unsubscribe();
  }

  private evaluateFeature(): void {
    const viewRef: EmbeddedViewRef<any> =
      this.template.createEmbeddedView(null);
    const sectionFeatures: ListFeature[] =
      this.features[this._feature.section] || [];

    this.viewContainer.clear();

    if (
      this.configurationService.configuration.features?.enableAllFeatures ||
      sectionFeatures.length === 0
    ) {
      this.viewContainer.insert(viewRef, 0);
    } else {
      const [element] = viewRef.rootNodes as HTMLElement[];
      const { visible = true, editable = true } =
        sectionFeatures.find(
          (sectionFeature) =>
            sectionFeature.identifier === this._feature.identifier
        ) || {};

      if (visible === true) {
        this.viewContainer.insert(viewRef, 0);
        if (editable === false) {
          this.addBooleanAttribute(element, 'disabled');
        }
      }
    }
  }

  private addBooleanAttribute(
    element: HTMLElement,
    attribute: string
  ): HTMLElement {
    this.renderer.setAttribute(element, attribute, 'true');
    return element;
  }
}
